module.exports = __webpack_public_path__ + "media/icons/sort-by-down-5aeb18fd.png";